// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"cded760c","453":"9da13e97","803":"8c9d04c4"}[chunkId] + ".chunk.js";
};